<!--
 * @Description: 关于我们组件
 * @Author: Fore-Zhang
 * @Date: 2021-01-12 01:14:40
 * @LastEditTime: 2021-01-13 14:06:58
-->

<template>
  <div id="article">
    <div id="TopBTCotainer">
      <div id="titleContainer">
        <div id="previewIssueTitle"></div>
        <div id="close_bt" @click="returnPage()"><img src="../assets/preview_close_bt.png"/></div>
      </div>
    </div>
    <div id="articleScroller" :style="ScrollerStyle">
      <div id="ArticleContainer">
        <ArticleTopBanner/>
        <div id="ContentCotainer">
          <div id="articleTitle">
            <div class="titleZH">关于我们</div><div class="titleEN">ABOUT US</div>
          </div>
          <div id="articleContent">
            <p class="ArticleNomalText">
              感谢关注「动见」。
            </p>
            <p class="ArticleNomalText">
              欢迎所有朋友通过下面的方式与「动见」进行交流，一起为中国的营销创造更多“新可能”。
            </p>
            <p class="fakeLi ArticleNomalText">
              发送邮件到 <span style="color: #5282f6">insights@bytedance.com</span>
            </p>
            <p class="fakeLi ArticleNomalText">
              也可扫描下方的二维码关注「巨量算数」公众号
            </p>
            <p class="ArticleNomalText">
              <img src="../assets/aboutme_qrcode.jpg" width="100%">
            </p>
            <div id="articleSuggestContent">
              <div style="width: 100%;">
                <img class="bottomlogo" src="../assets/article_bottom_logo.png">
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div id="shareMasking"
         v-if="sharePageShow" @click="sharePageShow=false">
      <img src="../assets/share.png" style="width: 100%">
    </div>
  </div>
</template>
<script>
import pageStackStore from "../store/pageStackStore"

import ArticleTopBanner from "./ArticleTopBanner_aboutus";
import ArticleTitle from "./ArticleTitle";
import store from "../store";


export default {
  name: "Article",
  components:{
    ArticleTopBanner,
    ArticleTitle
  },
  data(){
    return {
      sharePageShow:false,
      showTopMenu:false,
      scroller:0,
    }
  },
  mounted:function () {
    var scrollerConfig = {
      '//Description' : 'Default scroller with no configuration',
      touchSpeed:1,
    };
    this.scroller = new Scroller('#articleScroller', scrollerConfig);

  },
  methods:{
    returnPage:function(){
      pageStackStore.commit('OpenCloseAboutUs')
    },
    viewClass:function (key) {
      this.thisClass=key;
      pageStackStore.commit('pushPageStack', this.$route.path)
      this.$router.replace('/ArticleList/'+(key+1));
    },
  },
  computed:{
    ScrollerStyle(){
      return {
        height:(store.state.WindowSize.WindowHeightRem-1.11)+'rem'
      }
    },
    ArticleContent(){
      return ()=>import('./'+this.$route.params.issue+'/Article'+this.$route.params.id+'.vue');
    },
  }
}
</script>

<style lang="less" scoped>
@fullWidth:11.25rem;
.fullWidhth{
  width: @fullWidth;
}

.fakeLi:before{
  content: "\2022";
  color: #3d73f6;
}

#articleSuggestContent,#articleSuggestContent div{
  width: 100%;
  text-align: center;
  line-height:.88rem;
  font-size:.4rem;
}

.bottomlogo{
  width:4.11rem;
  margin-left: (11.25-1.8-4.11)/2rem;
  margin-top:1.4rem;
  margin-bottom:1.5rem;
}

#article{
  .fullWidhth();

  position: absolute;
  top:.9rem;
  height: 100%;
  background: #ffffff;
  border-radius:.5rem .5rem 0rem 0rem;
  overflow: hidden;

  #TopBTCotainer{
    .fullWidhth();

    height: 1.31rem;
    background: #ffffff;
    position: absolute;
    left: 0px;
    top: 0px;
    z-index: 3;
    border-radius:.5rem .5rem 0rem 0rem;
    box-shadow: 0px 0px .15rem .01rem #cccccc;

    #titleContainer{
      .fullWidhth();

      #previewIssueTitle{
        width: 9.45rem;
        margin-left: .9rem;

        height: 1.31rem;
        line-height:1.31rem;
        font-size:.55rem;
        text-align: center;
        color: grey;
      }
      #close_bt{
        width: .33rem;
        margin-top: .51rem;

        img{
          width: 100%;
        }
      }
    }
  }

  #TopMenu{
    position: absolute;
    width: 1.77rem;
    top:1.15rem;
    left:8.58rem;
    z-index: 2;

    #TopMenuImg{
      position: absolute;
      left: 0px;
      top: 0px;
      width: 100%
    }
    #shareClickDiv{
      position: absolute;
      width: 1.77rem;
      height: .75rem;
      top: .3rem;
      left: 0rem;
    }
    #retrunClickDiv{
      position: absolute;
      width: 1.77rem;
      height: .75rem;
      top: 1.09rem;
      left: 0rem;
    }
  }
  #articleScroller{
    .fullWidhth();

    position: absolute;
    left: 0px;
    top: 1.31rem;

    #ArticleContainer{
      .fullWidhth();

      #ContentCotainer{
        width:9.45rem;
        margin:.9rem;

        #articleTitle{
          color: black;
          font-weight: bolder;
          width: 100%;
          line-height:.64rem;
          font-size:.56rem;

          .titleZH{
            color: #000000;
            font-size: 1em;
          }

          .titleEN{
            color: #666666;
            font-size: 0.5em;
            padding-top: 0.5em;
            padding-left: 1em;
          }
        }

        #articleContent{
          width: 100%;
          margin-top:.9rem;
        }
      }
    }
  }
  #shareMasking{
    position:fixed;
    left:0px;
    top:0px;
    z-index: 20;
    width:100%;
    height:100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/AboutUs.vue